import React from 'react'
import map from 'lodash/map'
import find from 'lodash/find'
import filter from 'lodash/filter'
import LanguageRow from './LanguageRow'
import classnames from 'classnames'

import {
  IProjectVersion,
} from '@SiteModules/ProjectVersion/types'

import {
  IOpenImportSrtPopupPayload,
  IOpenExternalTokenPopupPayload,
} from '@SiteModules/Popup/types'

import {
  ISubtitle,
  IDeleteLanguagePayload,
} from '@SiteModules/Subtitle/types'

import './LanguagesTable.scss'

interface LanguagesTableProps {
  readonly projectVersion: IProjectVersion
  readonly fullLanguagesView: boolean
  handleOpenImportSrtPopup(payload: IOpenImportSrtPopupPayload): void
  handleOpenExternalTokenPopup(payload: IOpenExternalTokenPopupPayload): void
  handleDeleteLanguage(payload: IDeleteLanguagePayload): void
}

const LanguagesTable: React.FC<LanguagesTableProps> = props => {
  const { projectVersion, fullLanguagesView } = props

  const transcription = find(projectVersion.subtitles, subtitle => subtitle.attributes.transcription)
  const translations = filter(projectVersion.subtitles, subtitle => !subtitle.attributes.transcription)

  const renderTableHeader = () => {
    return (
      <tr>
        <th className="LanguagesTable__language">
          Language
        </th>
        <th className="LanguagesTable__type">
          Type
        </th>
        <th className="LanguagesTable__status">
          Status
        </th>
        <th className="LanguagesTable__reviewed">
          Reviewed
        </th>
        <th className="LanguagesTable__more" />
      </tr>
    )
  }

  const transcriptionRow = (
      <LanguageRow
        key={0}
        index={0}
        subtitle={transcription as ISubtitle}
        isDisabled={projectVersion.attributes.isDisabled}
        projectVersionIsShortened={projectVersion.attributes.isShortened}
        handleOpenImportSrtPopup={props.handleOpenImportSrtPopup}
        handleOpenExternalTokenPopup={props.handleOpenExternalTokenPopup}
        handleDeleteLanguage={props.handleDeleteLanguage}
      />
    )

  const translationRows = map(translations, (translation, index) => {
    return (
      <LanguageRow
        key={index + 1}
        index={index + 1}
        subtitle={translation}
        isDisabled={projectVersion.attributes.isDisabled}
        projectVersionIsShortened={projectVersion.attributes.isShortened}
        handleOpenImportSrtPopup={props.handleOpenImportSrtPopup}
        handleOpenExternalTokenPopup={props.handleOpenExternalTokenPopup}
        handleDeleteLanguage={props.handleDeleteLanguage}
      />
    )
  })

  return (
    <div
      className={classnames(
        'LanguagesTable',
        { 'LanguagesTable__full': fullLanguagesView }
      )}
    >
      <table>
        <thead>
          {renderTableHeader()}
        </thead>
        <tbody
          className={classnames(
            'LanguagesTable__body',
            { 'LanguagesTable__body-full': fullLanguagesView }
          )}
        >
          {transcription && transcriptionRow}
          {translationRows}
        </tbody>
      </table>
    </div>
  )
}

export default LanguagesTable
